import React, { useContext } from 'react';
import { Context } from '../../../context/global-data-provider';
import { useMediaQuery } from 'react-responsive';
import Caroumal from '../../plugin/caroumal/caroumal';

import CategorySliderItem from './category-slider-item';

import './category-slider-style.css';

function CategorySlider({ path }) {
  const { categories } = useContext(Context);
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 735px)' });

  return (
    <div className="category-slider">
      {isTabletOrMobile ? (
        <TMSlider categories={categories} path={path} />
      ) : (
        <DesktopSlider categories={categories} path={path} />
      )}
    </div>
  );
}

const DesktopSlider = ({ categories, path }) => {
  const settings = {
    className: 'category-highlight',
    id: 'category-highlight',
    rtl: true,
    arrows: true,
    dots: false,
    draggable: false,
    minMoveToToggle: 30,
    autoWidth: true,
    nextElement: <span className="d-block caroumal-c-next coreSpritePagingChevron" aria-label="Next" />,
    prevElement: (
      <span
        className="d-block caroumal-c-prev  coreSpritePagingChevron"
        style={{ transform: 'scale(-1)' }}
        aria-label="Previous"
      />
    ),
  };

  return (
    <Caroumal {...settings}>
      {Object.keys(categories).map((key) => {
        return <CategorySliderItem path={path} category={categories[key]} key={key} />;
      })}
    </Caroumal>
  );
};

const TMSlider = ({ categories, path }) => {
  const settings = {
    className: 'category-highlight',
    id: 'category-highlight',
    rtl: true,
    arrows: true,
    dots: false,
    draggable: true,
    minMoveToToggle: 30,
    autoWidth: true,
  };

  return (
    <Caroumal {...settings}>
      {Object.keys(categories).map((key) => {
        return <CategorySliderItem path={path} category={categories[key]} key={key} />;
      })}
    </Caroumal>
  );
};

export default CategorySlider;
